// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IntegrationCallStepPagingResultModel from '../../model/integration-call-step-paging-result-model';
import IntegrationCallStepPagingResultDTO from '../dto/integration-call-step-paging-result-dto';
import dtoSchema from '../schemas/integration-call-step-paging-result-schema';
import IntegrationCallStepModel from '../../model/integration-call-step-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class IntegrationCallStepPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IntegrationCallStepPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => IntegrationCallStepModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: IntegrationCallStepModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<IntegrationCallStepPagingResultDTO>): IntegrationCallStepPagingResultModel;
  static toModel(dto: DeepPartial<IntegrationCallStepPagingResultDTO> | undefined | null): IntegrationCallStepPagingResultModel | undefined;
  static toModel(dto: DeepPartial<IntegrationCallStepPagingResultDTO> | undefined | null): IntegrationCallStepPagingResultModel | undefined {
    return dto ? new IntegrationCallStepPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IntegrationCallStepPagingResultModel> | IntegrationCallStepPagingResultModel): IntegrationCallStepPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as IntegrationCallStepPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for IntegrationCallStepPagingResultModel, can not map to IntegrationCallStepPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
